import { Heading } from '@alefeducation/ui-elements-library-core'
import React from 'react'

export const BASE_API = '/authoring-audit-trail-service/api/v1'
export const IAM_SERVICE = '/shared-iam-service'

export const ORGANIZATION_STORAGE_KEY = 'selectedOrganisation'
export const ORGANIZATION_NAME_STORAGE_KEY = 'selected_organisation_name'
export const ORGANIZATION_DEFAULT = 'shared'
export const ORGANIZATION_QUERY_KEY = 'organization'
export const ALEFUSER_STORAGE_KEY = 'alef_user'

export const DEFAULT_PAGE_SETTING: PageOptions = {
  pageNumber: 1,
  pageSize: 50
}

export const STATUS_TYPES = {
  PUBLISHED: 'published',
  IN_REVIEW: 'in_review',
  DRAFT: 'draft',
  TRANSIENT: 'transient',
  REWORK: 'rework',
  REVIEW: 'review'
} as const

export type STATUSES = typeof STATUS_TYPES[keyof typeof STATUS_TYPES]

export const CONTENT_TYPES_LIST = {
  ALL: 'ALL',
  CONTENT: 'Content',
  SKILL: 'Skill',
  OUTCOME: 'Outcome',
  ASSIGNMENT: 'Assignment',
  ACTIVITY: 'Activity',
  COURSE: 'Course',
  CONTENT_REPOSITORY: 'Content Repository',
  METADATA: 'Metadata',
  TAG: 'Tag',
  QUESTION: 'Question',
  SECTION: 'Section',
  ASSET: 'Asset',
  WORKSPACE: 'Workspace'
} as const

export const DEFAULT_CONTENT_TYPE = CONTENT_TYPES_LIST.ALL

export const CONTENT_TYPE_CCL_PATH = {
  [CONTENT_TYPES_LIST.CONTENT]: '#/contents',
  [CONTENT_TYPES_LIST.SKILL]: '#/skills',
  [CONTENT_TYPES_LIST.OUTCOME]: '#/curriculum',
  [CONTENT_TYPES_LIST.ASSIGNMENT]: '#/assignment',
  [CONTENT_TYPES_LIST.ACTIVITY]: '#/activityV2',
  [CONTENT_TYPES_LIST.COURSE]: '#/courses',
}

export type CONTENT_TYPE_KEYS = keyof typeof CONTENT_TYPES_LIST
export type CONTENT_TYPE = typeof CONTENT_TYPES_LIST[CONTENT_TYPE_KEYS]
export type CONTENT_TYPES_ARRAY = CONTENT_TYPE[]
export type CONTENT_TYPE_KEYS_ARRAY = CONTENT_TYPE_KEYS[]

export const CONTENT_TYPE_MAP_BACKEND: Record<CONTENT_TYPE, string> = {
  [CONTENT_TYPES_LIST.CONTENT]: 'content',
  [CONTENT_TYPES_LIST.SKILL]: 'skill',
  [CONTENT_TYPES_LIST.OUTCOME]: 'outcome',
  [CONTENT_TYPES_LIST.ALL]: 'general',
  [CONTENT_TYPES_LIST.ASSIGNMENT]: 'assignment',
  [CONTENT_TYPES_LIST.ACTIVITY]: 'activity',
  [CONTENT_TYPES_LIST.COURSE]: 'course',
  [CONTENT_TYPES_LIST.CONTENT_REPOSITORY]: 'CONTENT_REPOSITORY',
  [CONTENT_TYPES_LIST.METADATA]: 'metadata',
  [CONTENT_TYPES_LIST.TAG]: 'tag',
  [CONTENT_TYPES_LIST.QUESTION]: 'Question',
  [CONTENT_TYPES_LIST.SECTION]: 'Section',
  [CONTENT_TYPES_LIST.ASSET]: 'ASSET',
  [CONTENT_TYPES_LIST.WORKSPACE]: 'WORKSPACE'
}

export const CONTENT_TYPE_LABEL_FOR_FILTER_LIST: Record<CONTENT_TYPE, string> = {
  [CONTENT_TYPES_LIST.CONTENT]: 'Content',
  [CONTENT_TYPES_LIST.SKILL]: 'Skill',
  [CONTENT_TYPES_LIST.OUTCOME]: 'Outcome',
  [CONTENT_TYPES_LIST.ALL]: 'All',
  [CONTENT_TYPES_LIST.ASSIGNMENT]: 'Assignment',
  [CONTENT_TYPES_LIST.ACTIVITY]: 'Activity',
  [CONTENT_TYPES_LIST.COURSE]: 'Course',
  [CONTENT_TYPES_LIST.CONTENT_REPOSITORY]: 'Content Repository',
  [CONTENT_TYPES_LIST.METADATA]: 'Metadata',
  [CONTENT_TYPES_LIST.TAG]: 'Tag',
  [CONTENT_TYPES_LIST.QUESTION]: 'Question',
  [CONTENT_TYPES_LIST.SECTION]: 'Section',
  [CONTENT_TYPES_LIST.ASSET]: 'Asset',
  [CONTENT_TYPES_LIST.WORKSPACE]: 'Workspace'
}

export const SHOW_ALL_CONTENT_OPTION = false

export type ENTITY_TYPES = Exclude<CONTENT_TYPE_KEYS, 'ALL'>

export const NameHeading = (repoName: string) => (
  <Heading variant="heading-xl" weight="bold" color="interactive.160">
    {repoName}
  </Heading>
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HEADING_COMPONENTS: Partial<Record<ENTITY_TYPES, (props: any) => JSX.Element>> = {
  CONTENT_REPOSITORY: NameHeading,
  CONTENT: NameHeading,
  ACTIVITY: NameHeading
}

export const SELECT_OPTION_MESSAGES = {
  error: 'Something went wrong.',
  empty: 'No users found.'
}
